import React, { Component } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import Alert from "@mui/material/Alert";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import Button from "../../components/Custom/Button/Button";
import SearchIcon from "@material-ui/icons/Search";
import ApiService from "../../ApiService";
import TableIcons from "../common/TableLogoComponent";
import MaterialTable from "../../components/MaterialTable";
import { format } from "date-fns";

const useStyles = (theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
    marginTop: 7,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

class RRWireSummaryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failed: false,
      success: false,
      responsemessage: null,
      fromDate: null,
      toDate: null,
      fromDueDate: null,
      toDueDate: null,
      merchantTerminals: [],
      merchants: [],
      loading: false,
      selectedMerchant: null,
      selectedTerminal: null,
      status: "",
      tableData: [],
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      fromDueTime: new Date().setHours(0, 0, 0),
      toDueTime: new Date().setHours(23, 59, 59),
      fromTimeStr: "00:00:00",
      toTimeStr: "23:59:59",
      fromDueTimeStr: "00:00:00",
      toDueTimeStr: "23:59:59",
    };
  }
  componentDidMount() {
    this.fetchMerchantTerminals();
    this.fetchAllMerchants();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.success && prevState.success !== this.state.success) {
      this.clearMessage();
    }
    if (this.state.failed && prevState.failed !== this.state.failed) {
      this.clearMessage();
    }
  }

  clearMessage = () => {
    setTimeout(() => {
      this.setState({
        success: false,
        failed: false,
        responsemessage: null,
      });
    }, 3000);
  };
  fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  };
  fetchMerchantTerminals = () => {
    ApiService.fetchMerchantTerminals().then((res) => {
      this.setState({ merchantTerminals: res.data });
    });
  };

  handleMerchantChange = (event, newValue) => {
    const selectedMer = newValue ? newValue.id : null;
    if (selectedMer) {
      this.setState({ selectedMerchant: selectedMer });
      this.showTerminalsById(selectedMer);
    } else {
      this.setState({
        selectedMerchant: null,
        selectedTerminal: null,
        entityId: null,
      });
      this.fetchMerchantTerminals();
    }
  };
  showTerminalsById = (merchantId) => {
    if (merchantId || merchantId !== null) {
      ApiService.fetchMerchantTerminalsByMerId(merchantId)
        .then((res) => {
          this.setState({ merchantTerminals: res.data });
        })
        .catch((e) => {});
    }
  };

  terminalSelected = (event, newValue) => {
    if (newValue && typeof newValue === "object") {
      const terminal = newValue;
      this.setState({ selectedTerminal: terminal });
    } else {
      this.setState({ selectedTerminal: null });
    }
  };
  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleClose() {
    this.setState({ loading: false });
  }
  clearData = () => {
    this.setState({
      fromDate: null,
      toDate: null,
      fromDueDate: null,
      toDueDate: null,
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      fromDueTime: new Date().setHours(0, 0, 0),
      toDueTime: new Date().setHours(23, 59, 59),
      fromTimeStr: "00:00:00",
      toTimeStr: "23:59:59",
      fromDueTimeStr: "00:00:00",
      toDueTimeStr: "23:59:59",
      selectedMerchant: null,
      selectedTerminal: null,
      status: "",
      tableData: [],
    });
  };
  search = () => {
    if (
      this.state.selectedTerminal === null ||
      this.state.status === "" ||
      ((this.state.fromDate === null || this.state.toDate === null) &&
        (this.state.fromDueDate === null || this.state.toDueDate === null))
    ) {
      this.setState({
        failed: true,
        success: false,
        responsemessage:
          "Please select Terminal and Status. Either Select Settlement From Date and Settlement To Date or From Due Date and To Due Date too.",
      });
    } else {
      this.setState({ loading: true });
      var reqForm = {
        validFrom: this.state.fromDate
          ? format(this.state.fromDate, "yyyyMMdd") +
            " " +
            this.state.fromTimeStr
          : null,
        validTo: this.state.toDate
          ? format(this.state.toDate, "yyyyMMdd") + " " + this.state.toTimeStr
          : null,

        dueFrom: this.state.fromDueDate
          ? format(this.state.fromDueDate, "yyyyMMdd") +
            " " +
            this.state.fromDueTimeStr
          : null,
        dueTo: this.state.toDueDate
          ? format(this.state.toDueDate, "yyyyMMdd") +
            " " +
            this.state.toDueTimeStr
          : null,
        terminalId: this.state.selectedTerminal.terminalId,
        status: this.state.status,
      };

      var request = Object.assign({}, reqForm);
      ApiService.fetchRollingReserveSummary(request)
        .then((res) => {
          if (res.data.status === "OK") {
            this.setState({
              tableData: res.data.responseEntity,
              failed: false,
              success: true,
              loading: false,
              responsemessage: "Successfully Fetched.",
            });
          } else {
            this.setState({
              tableData: [],
              tableData: res.data.responseEntity,
              failed: true,
              success: false,
              loading: false,
              responsemessage: res.data.responseMessage,
            });
          }
        })
        .catch((e) => {
          this.setState({
            tableData: [],
            failed: true,
            success: false,
            loading: false,
            responsemessage: e,
          });
        });
    }
  };
  render() {
    const { classes } = this.props;
    const { merchantTerminals } = this.state;
    return (
      <Paper style={{ margin: "1em", padding: "1em" }}>
        <Typography
          component="h2"
          variant="h6"
          color="primary"
          style={{ marginLeft: "0.7em" }}
          gutterBottom
        >
          Rolling Reserve Wire Summary
        </Typography>
        {this.state.failed && (
          <Alert severity="error" elevation={0}>
            {" "}
            {this.state.responsemessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert severity="success" elevation={0}>
            {" "}
            {this.state.responsemessage}
          </Alert>
        )}
        <Grid container xs={12} spacing={1} style={{ marginLeft: "0.7em" }}>
          <Grid item xs={12}>
            <FormControl className={classes.formControl}>
              <Autocomplete
                options={this.state.merchants}
                getOptionLabel={(option) =>
                  option ? option.merchantName + "-" + option.code : ""
                }
                value={
                  this.state.merchants.find(
                    (merchant) => merchant.id === this.state.selectedMerchant
                  ) || null
                }
                style={{ marginTop: "0.2em" }}
                onChange={this.handleMerchantChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Merchants"
                    fullWidth
                    variant="standard"
                    size="small"
                  />
                )}
              />
            </FormControl>
            &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;
            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;
            <FormControl className={classes.formControl}>
              <Autocomplete
                value={this.state.selectedTerminal}
                onChange={this.terminalSelected}
                options={merchantTerminals}
                getOptionLabel={(option) =>
                  option ? option.label + "-" + option.terminalCardType : ""
                }
                renderInput={(params) => (
                  <TextField {...params} label="Terminals" />
                )}
              />
            </FormControl>
            &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;
            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">
                Status
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.status}
                onChange={this.handleStatusChange}
                label="Status"
              >
                <MenuItem value="ALL">ALL</MenuItem>
                <MenuItem value="HELD">HELD</MenuItem>
                <MenuItem value="RELEASED">RELEASED</MenuItem>
              </Select>
            </FormControl>
            &nbsp; &nbsp; &nbsp;
            <br />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                autoOk
                label="Settlement From"
                format="dd MMM yyyy"
                value={this.state.fromDate}
                onChange={(val) => this.setState({ fromDate: val })}
                style={{ marginTop: 12 }}
              />
              &nbsp; &nbsp; &nbsp;
              <TimePicker
                label="From Time"
                views={["hours", "minutes", "seconds"]}
                value={this.state.fromTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    fromTime: val,
                    fromTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ marginTop: 12 }}
              ></TimePicker>
              &nbsp; &nbsp; &nbsp;
              <DatePicker
                autoOk
                label="Settlement To"
                format="dd MMM yyyy"
                value={this.state.toDate}
                onChange={(val) => this.setState({ toDate: val })}
                style={{ marginTop: 12 }}
              />
              &nbsp; &nbsp; &nbsp;
              <TimePicker
                label="To Time"
                className="timePicker"
                views={["hours", "minutes", "seconds"]}
                value={this.state.toTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    toTime: val,
                    toTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ marginTop: 12 }}
              ></TimePicker>
              &nbsp; &nbsp; &nbsp;
              <br />
              <DatePicker
                autoOk
                label="Due From"
                format="dd MMM yyyy"
                value={this.state.fromDueDate}
                onChange={(val) => this.setState({ fromDueDate: val })}
                style={{ marginTop: 12 }}
              />
              &nbsp; &nbsp; &nbsp;
              <TimePicker
                label="Due From Time"
                views={["hours", "minutes", "seconds"]}
                value={this.state.fromDueTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    fromDueTime: val,
                    fromDueTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ marginTop: 12 }}
              ></TimePicker>
              &nbsp; &nbsp; &nbsp;
              <DatePicker
                autoOk
                label="Due To"
                format="dd MMM yyyy"
                value={this.state.toDueDate}
                onChange={(val) => this.setState({ toDueDate: val })}
                style={{ marginTop: 12 }}
              />
              &nbsp; &nbsp; &nbsp;
              <TimePicker
                label="Due To Time"
                views={["hours", "minutes", "seconds"]}
                value={this.state.toDueTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    toDueTime: val,
                    toDueTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ marginTop: 12 }}
              ></TimePicker>
            </MuiPickersUtilsProvider>
            &nbsp; &nbsp; &nbsp;
            <br />
            <Button
              style={{ marginTop: 30, marginLeft: 300 }}
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SearchIcon />}
              onClick={this.search}
            >
              Search
            </Button>
            <Button
              style={{ marginTop: 30, marginLeft: 20 }}
              variant="contained"
              color="primary"
              size="small"
              startIcon={<HighlightOffIcon />}
              onClick={this.clearData}
            >
              Clear
            </Button>
            <Backdrop
              open={this.state.loading}
              className={classes.backdrop}
              onClick={this.handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Grid>
        </Grid>
        <MaterialTable
          style={{ margin: "2em 0 0 0" }}
          title="Rolling Reserve Summary"
          icons={TableIcons.icons}
          columns={[
            { field: "status", title: "STATUS" },
            { field: "wireCount", title: "COUNT" },
            { field: "currency", title: "CURRENCY" },
            {
              field: "totalRrAmount",
              title: "TOTAL AMOUNT",
              render: (rowData) => (
                <Typography variant="inherit">
                  {rowData.totalRrAmount && rowData.totalRrAmount.toFixed(2)}
                </Typography>
              ),
            },
            { field: "dateRange", title: "SETTLEMENT DATE RANGE" },
          ]}
          data={this.state.tableData}
          options={{
            search: false,
            exportButton: true,
            pageSize: 20,
            pageSizeOptions: [20, 50, 100],
            padding: "default",
            showEmptyDataSourceMessage: true,
            selection: false,
            actionsColumnIndex: -1,
            tableLayout: "auto",
            emptyRowsWhenPaging: false,
          }}
        />
      </Paper>
    );
  }
}

export default withStyles(useStyles)(RRWireSummaryComponent);
